import { useEffect, useRef } from "react";

/**
 * Reveals its children when scrolled into view.
 * Uses [data-anim="fade-up"] hook defined in index.css.
 */
export default function Reveal({ as = "div", delay = 0, className = "", children, ...rest }) {
  const ref = useRef(null);
  const Tag = as;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add("in"), delay);
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "-10% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} data-anim="fade-up" className={className} {...rest}>
      {children}
    </Tag>
  );
}
